import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {t} from '../../Translations';
import Nav from "./Nav";
import Button from "./Button";
import Car from '../icons/Car';
import User from '../icons/User';

/**
 * Component for the top nav
 */
const NavTop = ({activeStep,client, onClose}) => (
    <div className={"main-menu nav-top-digital-one row"+client} style={{paddingTop:0}}>
        <Nav active={activeStep}>
            <div className={"menu-step menu-step-digital-one"+client}>
                <Car className="icon" />
                <span className={"menu-text"+client}>{t('Tab_vehicle')}</span>
            </div>
            <div className={"menu-step menu-step-digital-one"+client}>
                <User className="icon" />
                <span className={"menu-text"+client}>{t('Tab_usage')}</span>
            </div>
        </Nav>

        <Button className="btn-close-widget" onClick={onClose}>
            <span className="icon icon-fermer" aria-hidden="true" />
        </Button>
    </div>
);

NavTop.propTypes = {
    activeStep: PropTypes.number,
    client:PropTypes.string
};

NavTop.defaultProps = {
    activeStep: 0,
    client:""
};

export default NavTop;


// WEBPACK FOOTER //
// ./src/components/widgets/NavTop.js